<template>
  <b-modal
    id="editTemplate"
    ref="editTemplate"
    size="xl"
    :title="modalTitle"
    hide-footer
    no-enforce-focus
    @hide="hideModal"
  >
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="page-content">
            <div class="ibox">
              <form>
                <div class="ibox-body">
                  <div class="form-group mb-4 row">
                    <label
                      for="title"
                      class="col-sm-2 col-form-label font-weight-500"
                      >テンプレート名（必須）</label
                    >
                    <div class="col-sm-7">
                      <input
                        class="form-control custom-input"
                        type="text"
                        data-vv-as="テンプレート名"
                        placeholder="任意のテンプレート名を入力してください"
                        id="title"
                        v-validate="'required'"
                        name="Name"
                        v-model="name"
                      />
                      <div class="error">
                        <FieldError
                          :message="$validator.errors.first('Name')"
                        />
                      </div>
                    </div>
                    <div class="col-sm-3">
                      <div class="param-value">
                        <span class="font-bold">テンプレートに利用可能なパラメータ</span> <br /><br/>
                        スカウトする登録者の苗字: <br/>
                        %jobseeker.last_name%
                      </div>
                    </div>
                  </div>

                  <div class="form-group mb-4 row">
                    <label
                      for="title"
                      class="col-sm-2 col-form-label font-weight-500"
                      >スカウト形式（必須）</label
                    >
                    <div class="col-sm-7 radio-labels">
                      <div class="d-flex justify-content-between">
                          <label class="mr-3"
                          ><input
                            type="radio"
                            name="contactType"
                            value="応募案内"
                            v-model="contactType"
                          />
                          応募案内</label
                        >
                        <label class="mr-3"
                          ><input
                            type="radio"
                            name="contactType"
                            value="カジュアル面談"
                            v-model="contactType"
                          />
                          カジュアル面談</label
                        >
                        <label class="mr-3"
                          ><input
                            type="radio"
                            name="contactType"
                            value="面接案内"
                            v-model="contactType"
                          />
                          面接案内</label
                        >

                        <div class="d-flex flex-column">
                          <label>
                            <input 
                              type="radio" 
                              name="contactType" 
                              value="その他通知" 
                              v-model="contactType"> 
                              通知のみ
                           </label>
                          <small class="text-muted d-block mt-1">※通知のみは、求人添付および登録者からの回答受付はできません。                          </small>
                          </div>
                        </div>
                      </div>
                    <div class="col-sm-3">
                      <div class="param-value">
                        添付するスカウト求人のタイトル: <br />
                        %selected_jd_title%
                      </div>
                    </div>
                  </div>

                  <div class="form-group mb-4 row">
                    <label
                      for="jd_title"
                      class="col-sm-2 col-form-label font-weight-500"
                      >添付求人</label
                    >
                    <div class="col-sm-7">
                      <input
                        class="form-control custom-input"
                        type="text"
                        data-vv-as="スカウトする求人名"
                        placeholder="スカウトする求人をシステムから選択する際はパラメータを入力してください"
                        id="jd_title"
                        name="jd_title"
                        v-model="jd_title"
                      />
                      <div class="error">
                        <FieldError
                          :message="$validator.errors.first('JobTitle')"
                        />
                      </div>
                    </div>
  
                  </div>

                  <div class="form-group mb-4 row">
                    <label
                      for="sender"
                      class="col-sm-2 col-form-label font-weight-500"
                      >差出人名
                      </label
                    >
                    <div class="col-sm-7">
                      <input
                        class="form-control custom-input"
                        type="text"
                        data-vv-as="送信者名"
                        placeholder="スカウトの差出人として表示するお名前を入力してください"
                        id="sender"
                        name="Sender"
                        v-model="sender"
                      />
                      <div class="error">
                        <FieldError
                          :message="$validator.errors.first('Sender')"
                        />
                      </div>
                    </div>
                  </div>
                  
                  <div class="form-group mb-4 row">
                    <label
                      for="title"
                      class="col-sm-2 col-form-label font-weight-500"
                      >件名（必須）</label
                    >
                    <div class="col-sm-7">
                      <input
                        class="form-control custom-input"
                        type="text"
                        data-vv-as="件名"
                        id="title"
                        v-validate="'required'"
                        name="Subject"
                        v-model="subject"
                      />
                      <div class="error">
                        <FieldError
                          :message="$validator.errors.first('Subject')"
                        />
                      </div>
                    </div>
                    <div></div>
                  </div>

                  <div class="form-group mb-4 row">
                    <label
                      for="code"
                      class="col-sm-2 col-form-label font-weight-500"
                      >本文(必須)</label
                    >
                    <div class="col-sm-7">
                      <Editor
                        v-if="showEditTemplateModal"
                        :init="tinyMceConfig"
                        class="form-control custom-input"
                        placeholder="Enter Message Body"
                        id="meta_description"
                        v-model="message_body"
                      />
                      <div class="error">
                        <FieldError
                          :message="$validator.errors.first('MessageBody')"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="justify-content-center row">
                  <div class="d-flex justify-content-center actions">
                    <button
                      class="btn btn-white mr-4 btn-action"
                      type="reset"
                      @click.prevent="reset"
                    >
                      {{ editModalData ? '上書き保存' : 'キャンセル' }}
                    </button>
                    <button
                      class="btn btn-action"
                      :class="editModalData ? 'btn-red' : 'btn-blue'"
                      type="submit"
                      :disabled="isSubmitting"
                      @click.prevent="submitAction"
                    >
                      {{ editModalData ? '別名で新規保存' : '保存する' }}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <MessageTemplateModal
        @hide-modal="onHideModal"
        @rowSelected="onTemplateSelected"
        v-if="showMessageTemplateModal"
      />
    </div>
  </b-modal>
</template>

<script>
import DOMPurify from 'dompurify';
import { mapActions, mapGetters } from 'vuex';
import Editor from '@tinymce/tinymce-vue';
import FieldError from '../../../utils/FieldError.vue';
import MessageTemplateModal from './MessageTemplateModal.vue';
import ApiService from '@/service/apiService';
import API from '@/config/api';

export default {
  name: 'EditMessageTemplate',
  components: {
    Editor,
    FieldError,
    MessageTemplateModal,
  },
  props: {
    id: String | undefined,
    editModalData: Object | undefined,
    page_title: String,
    showEditTemplateModal: Boolean,
    isReplyTemplate: Boolean | false,
  },
  data() {
    return {
      tinyMceConfig: {
        height: 400,
        theme: 'modern',
        plugins: [
          'advlist autolink lists link charmap print preview fullpage hr anchor pagebreak',
          'searchreplace powerpaste wordcount visualblocks visualchars code fullscreen advcode',
          'insertdatetime nonbreaking save contextmenu directionality tinymcespellchecker a11ychecker linkchecker',
          'template paste textcolor colorpicker textpattern mediaembed codesample toc code responsivefilemanager help',
        ],
        toolbar1:
          'undo redo | insert | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image | removeformat',
        toolbar2: 'print preview media | forecolor backcolor code',
        image_advtab: true,
        templates: [
          { title: 'Test template 1', content: 'Test 1' },
          { title: 'Test template 2', content: 'Test 2' },
        ],
        content_css: [
          'https://fonts.googleapis.com/css?family=Poppins:200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i',
        ],
      },
      name: '',
      subject: '',
      message_body: '',
      jd_url: '',
      jd_title: '',
      questionRequest: false,
      contactType: '応募案内',
      sender: '',
      jdDisplay: false,
      isMessageValid: false,
      isDisabled: false,
      showMessageTemplateModal: false,
      selectedTemplate: undefined,
      parameters: {
        貴社名: '%company%',
        送信者名: '%user_name%',
        '登録ユーザー名(姓)': '%jobseeker.last_name%',
        '選択したJDタイトル(ポジション名)': '%selected_jd_title%',
        選択したJD詳細: '%selected_jd_detail%',
        選択したJD要件: '%selected_jd_qualification%',
        選択したJD勤務地: '%selected_jd_location%',
        選択したJD年収: '%selected_jd_salary%',
      },
      isSubmitting: false,
    };
  },
  methods: {
    ...mapActions([
      'loadAllMessageTemplates',
      'getOrLoadMessageTemplates',
      'addFlashMessages',
      'removeAllFlashMessages',
      'removeFlashMessage',
    ]),
    clearForm() {
      this.message_body = '';
    },
    show() {
      this.$refs.editTemplate.show();
      this.$nextTick(() => {
        const editor = window.tinymce.get('meta_description');
        if (editor) editor.focus();
      });
    },
    hideModal() {
      this.$emit('close');
      this.clearForm();
      if (window.tinymce) {
        window.tinymce.remove('#meta_description');
      }
      this.$refs.editTemplate.hide();
    },
    openMessageTemplateModal() {
      this.showMessageTemplateModal = true;
    },
    onHideModal() {
      this.showMessageTemplateModal = false;
    },
    async onTemplateSelected(id) {
      this.selectedTemplate = undefined;
      let allTemplates = await this.getOrLoadMessageTemplates();
      this.selectedTemplate = allTemplates.find(
        (template) => template._id === id
      );
      // console.log(this.selectedTemplate);
      window.scrollTo(0, 0);
      this.onHideModal();
    },
    async submit(saveAsnew = false) {
      this.isDisabled = true;
      let isOk = await this.$validator.validate();

      this.validateMessageBody();

      if (!isOk || !this.isMessageValid) {
        let element = document.getElementsByClassName('is-invalid ')[0];
        if (element) {
          element.scrollIntoView();
        }
        if (!this.isMessageValid) {
          this.$validator.errors.add({
            field: 'MessageBody',
            msg: '本文は必須項目です',
          });
        }
      } else {
        // scroll to top
        // window.scrollTo(0, 0);
        const messageBody = DOMPurify.sanitize(this.message_body, {
          ADD_ATTR: ['target'],
        });
        // if (this.isReplyTemplate) {
        //   this.contactType = 'その他通知';
        // }
        const payload = {
          name: this.name,
          subject: this.subject,
          message_body: messageBody,
          job_title: this.jd_title,
          job_url: this.jd_url,
          contact_type: this.contactType,
          question_request: this.questionRequest,
          sender: this.sender,
          jd_display: this.jdDisplay,
          // is_reply_template: this.isReplyTemplate,
          // id: this.editModalData.id,
        };
        this.submitHandler(payload, saveAsnew);
        // this.$emit("custom:submit", {
        //   name: this.name,
        //   subject: this.subject,
        //   message_body: messageBody,
        //   job_title: this.jd_title,
        //   job_url: this.jd_url,
        //   contact_type: this.contactType,
        //   question_request: this.questionRequest,
        //   sender: this.sender,
        //   jd_display: this.jdDisplay,
        //   id: this.id
        // })
      }
      this.isDisabled = false;
    },
    async submitHandler(payload, saveAsnew) {
      try {
        this.isSubmitting = true;
        let res;
        if (this.editModalData && !saveAsnew) {
          let editPayload = { ...payload, id: this.editModalData._id };
          res = await ApiService.put(
            API.endpoints.EDIT_MESSAGE_TEMPLATE(editPayload.id),
            editPayload
          );
        } else {
          res = await ApiService.post(
            API.endpoints.ADD_MESSAGE_TEMPLATE,
            payload
          );
        }

        this.addFlashMessages([
          { message: res.data.data.success, type: 'success' },
        ]);
        setTimeout(() => {
          this.removeAllFlashMessages();
        }, 5000);
        this.isSubmitting = false;
        await this.loadAllMessageTemplates();
        this.hideModal();
      } catch (err) {
        console.log(err);
        this.isSubmitting = false;
        this.errors = [];
        let messages = [];

        this.parseErrorResponse(err.response);
        let error = this.errors[0];
        for (let key of Object.keys(error)) {
          messages.push({ message: error[key].msg, type: 'danger' });
        }

        this.addFlashMessages([...messages]);
        setTimeout(() => {
          this.removeAllFlashMessages();
        }, 5000);
      }
    },
    reset() {
      if (this.editModalData) {
        this.submit();
      } else {
        this.hideModal();
      }
      // this.$router.push({name: "message-template"});
    },
    submitAction() {
      this.submit(true);
    },
    validateMessageBody() {
      // this.isMessageValid = this.message_body.trim() !== '';
      const bodyContentMatch = this.message_body.match(
        /<body[^>]*>[\s\S]*<\/body>/i
      );
      const bodyContent = bodyContentMatch ? bodyContentMatch[0] : '';
      // Example validation: Check if the extracted content is not empty
      const userEnteredContent = bodyContent
        .replace(/<\/?[^>]+(>|$)/g, '')
        .trim();

      const content2 = this.message_body.replace(/<\/?[^>]+(>|$)/g, '').trim();

      this.isMessageValid = content2 || userEnteredContent !== '';

      // this.isMessageValid = userEnteredContent !== '';
    },
  },
  computed: {
    ...mapGetters(['getAllFlashMessages']),
    isOtherNotifications() {
      return this.contactType === 'その他通知';
    },
    modalTitle() {
      return this.editModalData
        ? 'テンプレート編集'
        : 'テンプレート新規作成';
    }
  },
  mounted() {
    this.$refs.editTemplate.show();
    if (this.editModalData) {
      const editModalData = this.editModalData;
      this.name = editModalData.name;
      this.subject = editModalData.subject;
      this.message_body = editModalData.body;
      this.jd_url = editModalData.job_url;
      this.jd_title = editModalData.job_title;
      this.sender = editModalData.sender;
      this.contactType = editModalData.contact_type
        ? editModalData.contact_type
        : '応募案内';
      this.questionRequest = editModalData.question_request
        ? editModalData.question_request
        : 'false';
      this.jdDisplay = editModalData.jd_display
        ? editModalData.jd_display
        : false;
    }
  },
  // async created() {
  //   if (this.id) {
  //     let allTemplate = await this.getOrLoadMessageTemplates();
  //     let template = allTemplate.find(template => this.id === template._id);

  //     if (template) {
  //       this.name = template.name;
  //       this.subject = template.subject;
  //       this.message_body = template.body;
  //       this.jd_url = template.job_url;
  //       this.jd_title = template.job_title;
  //       this.sender = template.sender;
  //       this.contactType = template.contact_type ? template.contact_type : '応募案内';
  //       this.questionRequest = template.question_request ? template.question_request : 'false';
  //       this.jdDisplay = template.jd_display ? template.jd_display : false;
  //     } else {
  //       this.addFlashMessages([{message: "テンプレートはありません。", type: "danger"}]);
  //       setTimeout(() => {
  //         this.$router.push({name: "message-template"});
  //         this.removeAllFlashMessages()
  //       }, 800)
  //     }
  //   }
  // },
  watch: {
    message_body: {
      handler() {
        this.validateMessageBody();
      },
      deep: true,
    },
    contactType(newVal) {
      if (newVal === 'その他通知') {
        this.questionRequest = false;
      }
    },
    // selectedTemplate: {
    //     handler(newTemplate){
    //         this.name = newTemplate ? newTemplate.name : '';
    //         this.subject = newTemplate ? newTemplate.subject : '';
    //         this.message_body = newTemplate ? newTemplate.body : '';
    //         this.jd_title = newTemplate ? newTemplate.job_title : '';
    //         this.jd_url = newTemplate ? newTemplate.job_url : '';
    //         this.contactType = newTemplate && newTemplate.contact_type ? newTemplate.contact_type : '応募案内';
    //         this.questionRequest = newTemplate ? newTemplate.question_request: 'false';
    //         this.sender = newTemplate ? newTemplate.sender: '';
    //         this.jdDisplay = newTemplate ? newTemplate.jd_display: false;
    //     },
    //     immediate:true
    // },
  },
};
</script>

<style scoped>
>>> .modal-xl {
  max-width: 90vw;
}
>>> .modal-header {
  border-bottom: none;
}

.btn-action {
  min-width: 165px;
  height: 50px;
  border-radius: 30px;
  padding: 6px;
}

.font-bold {
  font-weight: bold;
}

.page-heading p:hover {
  opacity: 0.8;
}

.page-content {
  margin-top: 5px;
}

.form-group input[type='radio'] {
  flex: 3 !important;
  width: 25px !important;
  height: 25px;
  vertical-align: middle;
}

.radio-labels {
  color: #617776;
}

.ibox-head {
  padding: 0 20px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 60px;
}

.ibox-footer {
  text-align: center;
  padding: 15px;
  border-top: 1px solid #eee;
}

.font-weight-500 {
  font-weight: 500;
}

.actions .btn-sm {
  border-radius: 0;
  padding: 0.45rem 1.25rem;
  min-width: 0;
  font-size: 14px;
}

.custom-input {
  border-radius: 2px;
  font-size: 0.9rem;
  color: black;
}
label {
  color: rgb(35, 35, 35);
}

.param-value {
  color: #036d6c;
}
.custom-input:focus {
  box-shadow: none;
  border-color: #036d6c !important;
}

/*for vvalidate*/
.is-valid {
  background: none !important;
  border-color: #ced4da !important;
}

.is-invalid {
  background: none !important;
}

.btn-secondary {
  border-radius: 4px !important;
  width: 135px;
  font-size: 18px !important;
  font-weight: bold;
  margin-right: 100px !important;
}

.btn-danger {
  width: 135px;
  background: #eb5757 !important;
  font-size: 18px !important;
  font-weight: bold;
}

input[type='checkbox'] {
  width: 25px;
  height: 25px;
}

.error > div {
  display: flex;
  justify-content: flex-end;
}
</style>
